"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M17 11C17.552 11 18 11.448 18 12C18 12.552 17.552 13 17 13H16.5C16.224 13 16 13.224 16 13.5V17.5C16 17.776 15.776 18 15.5 18H14.5C14.224 18 14 17.776 14 17.5V13.5C14 13.224 13.776 13 13.5 13H13C12.448 13 12 12.552 12 12C12 11.448 12.448 11 13 11H13.5C13.776 11 14 10.776 14 10.5V2.5C14 2.224 14.224 2 14.5 2H15.5C15.776 2 16 2.224 16 2.5V10.5C16 10.776 16.224 11 16.5 11H17ZM12 7C12.552 7 13 7.448 13 8C13 8.552 12.552 9 12 9H11.5C11.224 9 11 9.224 11 9.5V17.5C11 17.776 10.776 18 10.5 18H9.5C9.224 18 9 17.776 9 17.5V9.5C9 9.224 8.776 9 8.5 9H8C7.448 9 7 8.552 7 8C7 7.448 7.448 7 8 7H8.5C8.776 7 9 6.776 9 6.5V2.5C9 2.224 9.224 2 9.5 2H10.5C10.776 2 11 2.224 11 2.5V6.5C11 6.776 11.224 7 11.5 7H12ZM7 15C7.552 15 8 15.448 8 16C8 16.552 7.552 17 7 17H6.5C6.224 17 6 17.224 6 17.5C6 17.776 5.776 18 5.5 18H4.5C4.224 18 4 17.776 4 17.5C4 17.224 3.776 17 3.5 17H3C2.448 17 2 16.552 2 16C2 15.448 2.448 15 3 15H3.5C3.776 15 4 14.776 4 14.5V2.5C4 2.224 4.224 2 4.5 2H5.5C5.776 2 6 2.224 6 2.5V14.5C6 14.776 6.224 15 6.5 15H7Z",
    fill: "#727B7F"
  }));
};